import _ from "lodash";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import {
  getRethumbUrl,
  getArchivedText,
  getArchivedSortedSubjectListMemoized,
  getAttachmentUrlFromFieldValue,
  getSubjectStandardWithCode,
  onEnterOrSpaceKeyDown,
} from "Utils";
import { connect } from "react-redux";
import classes from "./InsightCountInfo.scss";
import { graphql, compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";
import UIModal from "UIComponents/UIModal";
import Loading from "UIComponents/Loading";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";
import {
  CloseOutlined,
  ArrowOutOutlined,
  MinusCircleOutlined,
} from "@toddle-edu/ds-icons";
import { openLinkInNewTab } from "modules/Services";
import {
  goToUnitPlanDetail,
  goToAssessmentInSchoolLibrary,
} from "modules/NavigationModule";
import { getDefaultUnitPlanImage } from "UnitPlans/modules/Utils";
import {
  getUnitPlansQuery,
  getAssessmentsQuery,
} from "UnitPlans/modules/UnitPlanQuery";
import {
  getUnitPlansFromCache,
  getAssessmentsFromCache,
} from "UnitPlans/modules/UnitPlanGraphqlHelpers";
import { CURRICULUM_CONFIGURATION } from "PlanningInsights/modules/Module";
import InsightCountPopover from "./Components/InsightCountPopover";
import classNames from "classnames";
import {
  CARD_TYPES,
  getInsightCountDataMemoized,
  getModalTitleMemoized,
} from "./utils";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import ACLStore from "lib/aclStore";
import { hasModuleAdminAccess, MODULES } from "lib/staffPermissionUtils";
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";
import { getExcludeUnitTooltipMemoized } from "PlanningInsights/modules/Utils";
import { ENABLE_ASSESSMENTS_IN_PYP } from "Constants/permissionConstants";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";
import { KeyboardNavigableList } from "UIComponents/KeyboardNavigableList";
import { getIsCombineCurriculumHomePageEnabled } from "Platform/modules/PlatformUtils";

const getRethumb = imageUrl => {
  const rethumbUrl = imageUrl
    ? getRethumbUrl({
        width: 144,
        height: 144,
        imageUrl: imageUrl,
        fitIn: true,
      })
    : "";
  return `url("${rethumbUrl}")`;
};

const MAX_SUBJECTS_TO_DISPLAY = 2;
class InsightCountInfo extends PureComponent {
  constructor(props) {
    super(props);
    this.listContainerRef = React.createRef();
    this.state = {
      showLEPopover: false,
      selectedUnitId: null,
      leAssessmentIds: null,
    };
    this.insightCountRef = {};
  }

  goToUnitPlanDetailsPage = ({ id }) => {
    const {
      openLinkInNewTab,
      isAdminTabActive,
      courseId,
      goToUnitPlanDetail,
      currentCurriculumProgramId,
    } = this.props;
    const mode = "view";

    if (isAdminTabActive) {
      let route;
      if (getIsCombineCurriculumHomePageEnabled()) {
        route = `/platform/my-home/school-library/units/${id}/view`;
      } else {
        route = `/platform/${currentCurriculumProgramId}/school-library/units/${id}/view`;
      }
      openLinkInNewTab({ url: route });
    } else {
      goToUnitPlanDetail({
        courseId,
        mode,
        unitPlanId: id,
        isOpenInNewTab: true,
        isUnitLibraryRoute: true,
      });
    }
  };

  goToAssessment = ({ id }) => {
    const { goToAssessmentInSchoolLibrary } = this.props;

    goToAssessmentInSchoolLibrary({
      id,
      isOpenInNewTab: true,
    });
  };

  updateInsightCountRef = ({ id, ref }) => {
    this.insightCountRef[id] = ref;
  };

  getInsightCountStyle = insightCount => {
    let style = {};
    if (insightCount > 0) {
      style = { textDecoration: "underline" };
    }
    return style;
  };

  toggleShowLEPopover = value => {
    this.setState({ showLEPopover: value });
  };
  updateSelectedUnitId = value => {
    this.setState({ selectedUnitId: value });
  };
  updateLeAssessmentIds = value => {
    this.setState({ leAssessmentIds: value });
  };

  onClickInsightCount = (insightCount, id, assessmentIds) => {
    if (insightCount > 0) {
      this.toggleShowLEPopover(true);
      this.updateSelectedUnitId(id);
      this.updateLeAssessmentIds(assessmentIds);
    }
  };

  onClosePopover = () => {
    this.toggleShowLEPopover(false);
    this.updateSelectedUnitId(null);
    this.updateLeAssessmentIds([]);
  };

  generateCard = ({
    imageUrl,
    title,
    subTitle,
    subjects,
    onClickOpenLinkSvg,
    id,
    unitPlanId,
    assessments,
    cardType = CARD_TYPES.ASSOCIATED_UNITS,
  }) => {
    const {
      showModalWithInsightsCount,
      isViewOnly,
      isAdmin,
      t,
      onClickExclude,
      isExcludingFromGrade,
      grade,
      isCurriculumPYP,
      testId,
      isTasksOrQuestions,
    } = this.props;
    const insightCount = _.get(assessments, "totalCount", 0);
    const edges = _.get(assessments, "edges", []);
    const assessmentIds = _.map(edges, edge => {
      return _.get(edge, "node.id", null);
    });

    const backgroundImage = getDefaultUnitPlanImage({
      id: unitPlanId,
      imageUrl,
      getRethumb,
    });

    const isLEPopover = _.isEqual(cardType, CARD_TYPES.LE_POPOVER);
    const isAssociatedUnitsCard = _.isEqual(
      cardType,
      CARD_TYPES.ASSOCIATED_UNITS
    );

    const unitPlanClasses = classNames({
      [classes.lePopoverCard]: isLEPopover,
      [classes.unitPlanCard]: !isLEPopover,
      [classes.clickableUnitPlanCard]: !isViewOnly,
    });

    const excludeUnitTooltip = getExcludeUnitTooltipMemoized({
      t,
      isCurriculumPYP,
      isExcludingFromProgrammeOverview: isExcludingFromGrade,
      grade,
    });

    return (
      <div
        key={id}
        className={unitPlanClasses}
        ref={ref => this.updateInsightCountRef({ ref, id })}
        data-test-id={`${testId}-${unitPlanId}-unitPlanCard`}
      >
        <div className={classes.image} style={{ backgroundImage }} />
        <div className={classes.details}>
          <Tooltip placement="top" tooltip={title}>
            <span
              className={classNames("text-label-2", "text-textDefault", [
                classes.unitTitle,
              ])}
              onClick={onClickOpenLinkSvg}
              data-test-id={`${testId}-${unitPlanId}-unitTitle`}
              tabIndex={0}
              onKeyDown={e => onEnterOrSpaceKeyDown(e, onClickOpenLinkSvg)}
            >
              {title}
            </span>
          </Tooltip>
          <div className="text-body-2 text-textSubtle">
            {isAssociatedUnitsCard ? (
              <MoreItemWithToolTip
                items={subjects}
                length={MAX_SUBJECTS_TO_DISPLAY}
                joinSymbol=", "
                trigger={["hover", "focus"]}
              />
            ) : (
              <div>{subTitle}</div>
            )}
          </div>
        </div>

        <div className={classes.showOnHover}>
          {isAdmin && cardType == CARD_TYPES.ASSOCIATED_UNITS ? (
            <Tooltip placement="bottom" tooltip={excludeUnitTooltip}>
              <IconButton
                onClick={() => {
                  onClickExclude({
                    unitPlan: {
                      id: unitPlanId,
                      label: title,
                    },
                    isExcludingFromGrade,
                    grade,
                  });
                }}
                icon={<MinusCircleOutlined />}
                size="small"
                variant="plain-default"
                testId={`${testId}-${unitPlanId}-excludeUnit`}
              />
            </Tooltip>
          ) : null}

          {!showModalWithInsightsCount || !isAssociatedUnitsCard ? (
            <Tooltip
              placement="bottom"
              tooltip={t("unitPlan:open_unit_in_new_tab")}
            >
              <IconButton
                onClick={onClickOpenLinkSvg}
                icon={<ArrowOutOutlined />}
                size="small"
                variant="plain-default"
                testId={`${testId}-${unitPlanId}-openLink`}
              />
            </Tooltip>
          ) : null}
        </div>
        {showModalWithInsightsCount &&
          isAssociatedUnitsCard &&
          !isTasksOrQuestions && (
            <div
              className={classNames({
                [classes.insightCount]: true,
                [classes.underlinedInsightCount]: insightCount > 0,
              })}
              onClick={e => {
                e.stopPropagation();
                this.onClickInsightCount(insightCount, id, assessmentIds);
              }}
              data-test-id={`${testId}-${unitPlanId}-insightCount`}
              tabIndex={insightCount > 0 ? 0 : -1}
              onKeyDown={e => {
                onEnterOrSpaceKeyDown(e, () => {
                  e.stopPropagation();
                  this.onClickInsightCount(insightCount, id, assessmentIds);
                });
              }}
            >
              {insightCount}
            </div>
          )}
      </div>
    );
  };

  onClickOpenLink = ({ id }) => {
    const { isTasksOrQuestions, isViewOnly } = this.props;
    if (isViewOnly) return;

    if (isTasksOrQuestions) {
      this.goToAssessment({ id });
    } else {
      this.goToUnitPlanDetailsPage({ id });
    }
  };

  getModalBodyCards = ({ cardData, id: subjectGroupId, t }) => {
    const {
      isTasksOrQuestions,
      getCurrentAssessmentTypes,
      isCurriculumPYP,
    } = this.props;

    return (
      <KeyboardNavigableList listContainerRef={this.listContainerRef}>
        <div className={classes.cardsContainer} ref={this.listContainerRef}>
          {_.map(cardData, data => {
            const { id } = data;
            const fields = _.get(data, "fields", []);
            const imageUrl = getAttachmentUrlFromFieldValue({
              fieldValue: _.get(data, "image", {}),
            });

            const title = _.get(data, "title.value", "");

            const subjects = _.map(
              getArchivedSortedSubjectListMemoized({
                subjectList: _.get(
                  _.find(fields, { uid: "subjects" }),
                  "resolvedMinimalTree.subjects",
                  []
                ),
              }),
              subject => {
                const { name = "", isArchived = false } = subject;
                return getArchivedText({ name, isArchived, t });
              }
            );

            const assessments = isCurriculumPYP
              ? _.get(
                  data,
                  "pypUnitInsight.0.elementAssessmentInsight.0.assessments",
                  {}
                )
              : _.get(data, "unitInsights.0.assessments", {});

            const currentAssessmentTypes = getCurrentAssessmentTypes();
            const subTitle = isTasksOrQuestions
              ? _.get(
                  currentAssessmentTypes[
                    _.get(data, "assessmentType.value", "le")
                  ],
                  "label",
                  ""
                )
              : null;

            return this.generateCard({
              id: `${subjectGroupId}-${id}`,
              unitPlanId: id,
              imageUrl,
              title,
              subTitle,
              subjects,
              assessments,
              cardType: isTasksOrQuestions
                ? CARD_TYPES.ASSOCIATED_TASKS
                : CARD_TYPES.ASSOCIATED_UNITS,
              onClickOpenLinkSvg: () => this.onClickOpenLink({ id }),
            });
          })}
        </div>
      </KeyboardNavigableList>
    );
  };

  render() {
    const {
      t,
      onClose,
      showModalWithInsightsCount,
      isLoading,
      coveredUnitPlans,
      coveredAssessments,
      isCurriculumPYP,
      isPYPAssessmentEnabled,
      nodeLabel,
      isViewOnly,
      plannerElementSetLabel,
      fetchSubjectGroups,
      testId,
      displayType,
      isTasksOrQuestions,
    } = this.props;

    const insightCountData = getInsightCountDataMemoized({
      isTasksOrQuestions,
      coveredAssessments,
      coveredUnitPlans,
      fetchSubjectGroups,
    });
    const groupBySubjectGroups = fetchSubjectGroups && !isTasksOrQuestions;

    const { showLEPopover, selectedUnitId, leAssessmentIds } = this.state;

    const title = getModalTitleMemoized({
      showModalWithInsightsCount,
      displayType,
      isCurriculumPYP,
      nodeLabel,
    });

    const unitsAssociatedSubheader =
      isCurriculumPYP && !isPYPAssessmentEnabled
        ? "common:associated_units_modal_subheader_pyp"
        : "common:associated_units_modal_subheader";

    return (
      <div className={classes.container}>
        <UIModal
          isOpen={true}
          modalContent={classes.modalContainer}
          onRequestClose={onClose}
        >
          {isLoading ? (
            <Loading />
          ) : (
            <React.Fragment>
              <div className={classes.modalHeader}>
                <div className={classes.heading}>
                  <div className={classNames("heading-4", classes.title)}>
                    {getSubjectStandardWithCode({
                      label: title,
                      shouldDangerouslyInjectLabel: isCurriculumPYP,
                    })}
                  </div>
                  <IconButton
                    onClick={onClose}
                    icon={<CloseOutlined />}
                    size="medium"
                    variant="plain"
                    data-test-id={`${testId}-closeModal`}
                  />
                </div>
                {showModalWithInsightsCount && displayType === "UNIT_PLANS" ? (
                  <div className="text-body-2">
                    {t(unitsAssociatedSubheader, {
                      label: plannerElementSetLabel,
                    })}
                  </div>
                ) : null}
              </div>
              <div
                className={classNames({
                  [classes.modalBody]: true,
                  [classes.groupedModalBody]: groupBySubjectGroups,
                })}
              >
                {groupBySubjectGroups
                  ? _.map(insightCountData, data => {
                      const { id, subjectGroup, unitPlans } = data;
                      const count = _.size(unitPlans);

                      if (count <= 0) return null;
                      return (
                        <div key={id}>
                          <div className={classes.subjectGroup}>
                            <div className="text-label-2 text-textDefault">
                              {subjectGroup}
                            </div>
                            <div className="text-body-2 text-textSubtle">
                              {t("common:label_unit", { count })}
                            </div>
                          </div>
                          {this.getModalBodyCards({
                            cardData: data.unitPlans,
                            id,
                            t,
                          })}
                        </div>
                      );
                    })
                  : this.getModalBodyCards({ cardData: insightCountData, t })}
              </div>
              {showLEPopover && (
                <InsightCountPopover
                  showLEPopover={showLEPopover}
                  leAssessmentIds={leAssessmentIds}
                  selectedUnitId={selectedUnitId}
                  getRethumb={getRethumb}
                  onClosePopover={this.onClosePopover}
                  insightCountRef={this.insightCountRef}
                  generateCard={this.generateCard}
                  isViewOnly={isViewOnly}
                  isCurriculumPYP={isCurriculumPYP}
                  isPYPAssessmentEnabled={isPYPAssessmentEnabled}
                />
              )}
            </React.Fragment>
          )}
        </UIModal>
      </div>
    );
  }
}

const getFilters = ({
  showModalWithInsightsCount,
  plannerElementNodeId,
  plannerElementType,
  isCurriculumPYP,
}) => {
  let filters = {},
    pypUnitInsightFilters = {};

  if (showModalWithInsightsCount) {
    if (isCurriculumPYP) {
      pypUnitInsightFilters = {
        nodes: [
          {
            type: plannerElementType,
            nodeIds: plannerElementNodeId ? [plannerElementNodeId] : [],
          },
        ],
      };
    } else filters = { nodeIds: [plannerElementNodeId] };
  }
  return { filters, pypUnitInsightFilters };
};

const getFiltersMemoized = _.memoize(
  params => getFilters(params),
  props => JSON.stringify(props)
);

const mapStateToProps = (state, ownProps) => {
  const {
    isOverallInsights,
    coveredUnitPlanIds,
    coveredAssessmentIds,
    coveredQuestionIds,
    showModalWithInsightsCount,
    plannerElementNodeId,
    plannerElementType,
  } = ownProps;

  const curriculumType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );

  const fieldUIDs = ["subjects"];

  const hasSubjectGroups = _.get(
    CURRICULUM_CONFIGURATION,
    [curriculumType, "hasSubjectGroups"],
    false
  );
  const fetchSubjectGroups = isOverallInsights && hasSubjectGroups;

  if (fetchSubjectGroups) {
    fieldUIDs.push("subjectGroup");
  }

  let displayType = "UNIT_PLANS";
  if (!_.isEmpty(coveredQuestionIds)) {
    displayType = "WORKSHEETS";
  } else if (
    _.isEmpty(coveredUnitPlanIds) &&
    !_.isEmpty(coveredAssessmentIds)
  ) {
    displayType = "ASSESSMENTS";
  }

  const isAdmin = hasModuleAdminAccess({
    moduleName: MODULES.PLANNING_INSIGHTS.id,
  });

  const isCurriculumPYP = _.isEqual(curriculumType, CURRICULUM_TYPE_PYP);
  const fetchPYPUnitInsights = isCurriculumPYP && showModalWithInsightsCount;
  const fetchUnitInsights = !isCurriculumPYP;

  const isPYPAssessmentEnabled = ACLStore.can(ENABLE_ASSESSMENTS_IN_PYP);

  const { filters, pypUnitInsightFilters } = getFiltersMemoized({
    showModalWithInsightsCount,
    plannerElementNodeId,
    plannerElementType,
    isCurriculumPYP,
  });

  const unitPlanFeedVariables = {
    ids: coveredUnitPlanIds,
    uids: fieldUIDs,
    fetchUnitInsights,
    fetchPYPUnitInsights,
  };

  if (fetchUnitInsights) {
    unitPlanFeedVariables["filters"] = filters;
  }

  if (fetchPYPUnitInsights) {
    unitPlanFeedVariables["pypUnitInsightFilters"] = pypUnitInsightFilters;
  }

  const courseId = state.teacher.selected_class.selected_course;
  const isAdminTabActive = state?.login?.activeTab == "admin";

  const { id: currentCurriculumProgramId } = _.get(
    state,
    "platform.currentCurriculumProgram"
  );

  const isTasksOrQuestions = _.includes(
    ["ASSESSMENTS", "WORKSHEETS"],
    displayType
  );

  return {
    fetchSubjectGroups,
    displayType,
    isTasksOrQuestions,
    isAdmin,
    isCurriculumPYP,
    unitPlanFeedVariables,
    isPYPAssessmentEnabled,
    courseId,
    isAdminTabActive,
    isData: true,
    isLoading: false,
    currentCurriculumProgramId,
  };
};

const mapActionCreatorsToProps = {
  openLinkInNewTab,
  goToAssessmentInSchoolLibrary,
  getCurrentAssessmentTypes,
  goToUnitPlanDetail,
};

const InsightCountInfoWrapper = compose(
  connect(mapStateToProps, mapActionCreatorsToProps),
  I18nHOC({ resource: ["common", "unitPlan", "planningInsights"] }),
  graphql(getUnitPlansQuery, {
    name: "getUnitPlans",
    skip: ({ isTasksOrQuestions }) => isTasksOrQuestions,
    options: ({ unitPlanFeedVariables }) => ({
      fetchPolicy: "cache-and-network",
      variables: unitPlanFeedVariables,
    }),
    props({
      getUnitPlans,
      ownProps: { unitPlanFeedVariables, isData, isLoading },
    }) {
      const data = getUnitPlansFromCache(unitPlanFeedVariables);

      return {
        coveredUnitPlans: data,
        isData: !_.isEmpty(data) && isData,
        isLoading:
          getUnitPlans["networkStatus"] == 1 ||
          getUnitPlans["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getAssessmentsQuery, {
    name: "getAssessments",
    skip: ({ isTasksOrQuestions }) => !isTasksOrQuestions,
    options: ({ displayType, coveredAssessmentIds, coveredQuestionIds }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        ids:
          displayType === "WORKSHEETS"
            ? coveredQuestionIds
            : coveredAssessmentIds,
      },
    }),
    props({ getAssessments }) {
      const data = getAssessmentsFromCache(getAssessments.variables);

      return {
        coveredAssessments: data,
        isData: !_.isEmpty(data),
        isLoading:
          getAssessments["networkStatus"] == 1 ||
          getAssessments["networkStatus"] == 2,
      };
    },
  })
)(InsightCountInfo);

InsightCountInfoWrapper.defaultProps = {
  coveredUnitPlanIds: [],
  coveredAssessmentIds: [],
  showModalWithInsightsCount: false,
  plannerElementNodeId: null,
  plannerElementSetLabel: "",
  plannerElementType: "",
  nodeLabel: null,
  isViewOnly: false,
  isOverallInsights: false,
};

InsightCountInfoWrapper.propTypes = {
  onClose: PropTypes.func.isRequired,
  coveredUnitPlanIds: PropTypes.array,
  plannerElementSetLabel: PropTypes.string,
  coveredAssessmentIds: PropTypes.array,
  showModalWithInsightsCount: PropTypes.bool,
  plannerElementNodeId: PropTypes.any,
  plannerElementType: PropTypes.string,
  nodeLabel: PropTypes.any,
  isViewOnly: PropTypes.bool,
  isOverallInsights: PropTypes.bool,
};

export default InsightCountInfoWrapper;
